import { render, staticRenderFns } from "./ReloadFintocByCompany.vue?vue&type=template&id=51355b64&scoped=true"
import script from "./ReloadFintocByCompany.vue?vue&type=script&lang=js"
export * from "./ReloadFintocByCompany.vue?vue&type=script&lang=js"
import style0 from "./ReloadFintocByCompany.vue?vue&type=style&index=0&id=51355b64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51355b64",
  null
  
)

export default component.exports